import React, { useState } from 'react';
import {
  Button,
  ButtonGroup,
  Menu,
  MenuItem,
  ListItemText,
  Typography,
} from '@mui/material';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';

// Code-named options surfaced to the user; the backend `value` is the
// dispatcher key (must match colony_pipeline.PIPELINES). Keep the list
// short — SAM zero-shot has been removed per 2026-05-28 product call.
export const COLONY_PIPELINE_OPTIONS = [
  { value: null,             label: 'Default',                 hint: 'production pipeline' },
  { value: 'two_stage',      label: 'Prototype MVys0.0',       hint: 'two stage' },
  { value: 'yolo_agar',      label: 'Prototype MVyAg1.0',      hint: 'species similarity' },
  { value: 'dino_agar',      label: 'Prototype MVrtAg1.0',     hint: 'species similarity (transformer)' },
  { value: 'hf_detr_agar',   label: 'Prototype MVm2fAg1.0',    hint: 'species similarity (instance masks)' },
  { value: 'find_similar',   label: 'Prototype MVds1.0',       hint: 'Find all Similar' },
  { value: 'morphological',  label: 'Morphological Operators', hint: 'Manual finetuning' },
];

/**
 * Split-button: main click runs Colony Count with the selected pipeline; the
 * dropdown chevron opens a menu to change the pipeline. Persists nothing —
 * parent owns `value` so the choice survives across the two toolbar mounts.
 */
export default function ColonyPipelinePicker({
  value,
  onChange,
  onRun,
  size = 'small',
  color = '#e65100',
  hoverColor = '#bf360c',
  disabled = false,
}) {
  const [anchorEl, setAnchorEl] = useState(null);
  const current = COLONY_PIPELINE_OPTIONS.find((o) => o.value === value) ?? COLONY_PIPELINE_OPTIONS[0];

  const isCustom = value && value !== null;
  const label = isCustom ? `Colony Count (${current.label})` : 'Colony Count';

  return (
    <>
      <ButtonGroup
        variant="contained"
        size={size}
        sx={{
          '& .MuiButtonGroup-grouped': {
            backgroundColor: color,
            color: '#fff',
            '&:hover': { backgroundColor: hoverColor },
          },
        }}
      >
        <Button onClick={onRun} disabled={disabled}>
          {label}
        </Button>
        <Button
          aria-label="select colony detection pipeline"
          onClick={(e) => setAnchorEl(e.currentTarget)}
          disabled={disabled}
          sx={{ minWidth: 28, px: 0.5 }}
        >
          <ArrowDropDownIcon fontSize="small" />
        </Button>
      </ButtonGroup>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={() => setAnchorEl(null)}
        slotProps={{ paper: { sx: { maxWidth: 340 } } }}
      >
        {COLONY_PIPELINE_OPTIONS.map((opt) => (
          <MenuItem
            key={opt.label}
            selected={opt.value === value}
            onClick={() => {
              onChange(opt.value);
              setAnchorEl(null);
            }}
          >
            <ListItemText
              primary={opt.label}
              secondary={
                <Typography variant="caption" sx={{ color: '#888' }}>
                  {opt.hint}
                </Typography>
              }
            />
          </MenuItem>
        ))}
      </Menu>
    </>
  );
}
